import * as React from "react";

const IconPaginationBlockRightHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><g fill="none" fillRule="evenodd"><path fill="#298CF0" d="M0 0h24v24H0z"/><path fill="#FFF" fillRule="nonzero" d="M18.467 12.545l.533-.543-.533-.544-4.813-4.914L13.122 6 12.06 7.085l.532.543 3.528 3.606H5v1.535h11.117l-3.528 3.603-.533.543L13.119 18l.532-.544z"/></g></svg>;
};

export default React.memo(IconPaginationBlockRightHover);
